export default __webpack_public_path__ + "static/media/white-arrow.b7a40b68.svg";